/**
 * IPIP-NEO population norms by gender and age group.
 * Source: IPIP Mean SD-120 sheet from CSI Score_PWZK.xlsx
 * Structure: NORMS[gender][ageGroup].facets[facetCode] = { mean, sd }
 *            NORMS[gender][ageGroup].domains[domainCode] = { mean, sd }
 */

export const NORMS = {
  M: {
    '<18': {
      facets: {
        N1: { mean: 11.468087, sd: 3.668047 },
        N2: { mean: 12.265461, sd: 4.331759 },
        N3: { mean: 9.404807, sd: 4.019016 },
        N4: { mean: 11.818831, sd: 3.550262 },
        N5: { mean: 11.420986, sd: 3.020254 },
        N6: { mean: 9.947473, sd: 3.31397 },
        C1: { mean: 15.378171, sd: 2.781045 },
        C2: { mean: 10.873043, sd: 3.870393 },
        C3: { mean: 14.784613, sd: 2.944992 },
        C4: { mean: 13.446135, sd: 3.611031 },
        C5: { mean: 12.713652, sd: 3.171579 },
        C6: { mean: 11.599678, sd: 4.038674 },
        A1: { mean: 13.238925, sd: 3.52544 },
        A2: { mean: 14.410159, sd: 3.390046 },
        A3: { mean: 14.988305, sd: 3.05201 },
        A4: { mean: 11.941551, sd: 3.830521 },
        A5: { mean: 12.013404, sd: 3.672822 },
        A6: { mean: 13.597671, sd: 3.452147 },
        E1: { mean: 14.485431, sd: 3.640561 },
        E2: { mean: 12.994896, sd: 4.116911 },
        E3: { mean: 13.854063, sd: 3.617329 },
        E4: { mean: 11.569772, sd: 3.142122 },
        E5: { mean: 14.527849, sd: 3.326992 },
        E6: { mean: 15.020788, sd: 3.538756 },
        O1: { mean: 15.60887, sd: 3.281803 },
        O2: { mean: 12.679708, sd: 4.081234 },
        O3: { mean: 13.668137, sd: 3.244976 },
        O4: { mean: 12.324306, sd: 3.026319 },
        O5: { mean: 13.930922, sd: 3.78015 },
        O6: { mean: 11.490808, sd: 3.042464 }
      },
      domains: {
        N: { mean: 66.325644, sd: 14.791802 },
        C: { mean: 78.795292, sd: 14.333603 },
        A: { mean: 80.190015, sd: 13.780902 },
        E: { mean: 82.4528, sd: 14.84535 },
        O: { mean: 79.70275, sd: 12.486846 }
      },
    },
    '18-24': {
      facets: {
        N1: { mean: 11.123704, sd: 3.63465 },
        N2: { mean: 10.995273, sd: 4.152962 },
        N3: { mean: 8.984812, sd: 3.771847 },
        N4: { mean: 11.498364, sd: 3.57688 },
        N5: { mean: 11.677825, sd: 3.271756 },
        N6: { mean: 9.311998, sd: 3.328414 },
        C1: { mean: 15.936607, sd: 2.5222 },
        C2: { mean: 12.450107, sd: 4.117264 },
        C3: { mean: 15.555911, sd: 2.729533 },
        C4: { mean: 14.571598, sd: 3.419766 },
        C5: { mean: 13.22387, sd: 3.193662 },
        C6: { mean: 13.05945, sd: 4.0007 },
        A1: { mean: 13.501162, sd: 3.472771 },
        A2: { mean: 15.239281, sd: 3.183311 },
        A3: { mean: 15.78858, sd: 2.758057 },
        A4: { mean: 13.788072, sd: 3.541088 },
        A5: { mean: 11.442814, sd: 3.406069 },
        A6: { mean: 13.873343, sd: 3.224774 },
        E1: { mean: 14.506905, sd: 3.553048 },
        E2: { mean: 12.655104, sd: 3.974748 },
        E3: { mean: 14.36859, sd: 3.381242 },
        E4: { mean: 11.935642, sd: 3.089995 },
        E5: { mean: 13.644591, sd: 3.227948 },
        E6: { mean: 15.25124, sd: 3.301532 },
        O1: { mean: 15.089438, sd: 3.275688 },
        O2: { mean: 13.618831, sd: 3.80423 },
        O3: { mean: 14.054095, sd: 3.093581 },
        O4: { mean: 12.34289, sd: 3.152352 },
        O5: { mean: 14.565795, sd: 3.566608 },
        O6: { mean: 11.209586, sd: 3.546154 }
      },
      domains: {
        N: { mean: 63.591977, sd: 14.969229 },
        C: { mean: 84.797543, sd: 14.173761 },
        A: { mean: 83.633252, sd: 12.558093 },
        E: { mean: 82.362073, sd: 14.303655 },
        O: { mean: 80.880635, sd: 12.564396 }
      },
    },
    '25-34': {
      facets: {
        N1: { mean: 10.920084, sd: 3.725192 },
        N2: { mean: 11.042289, sd: 4.221461 },
        N3: { mean: 9.216436, sd: 3.860865 },
        N4: { mean: 11.506171, sd: 3.691193 },
        N5: { mean: 11.860191, sd: 3.515046 },
        N6: { mean: 8.935986, sd: 3.454178 },
        C1: { mean: 16.145477, sd: 2.561835 },
        C2: { mean: 12.682794, sd: 4.286277 },
        C3: { mean: 15.769229, sd: 2.791332 },
        C4: { mean: 15.638145, sd: 3.313011 },
        C5: { mean: 13.81707, sd: 3.322491 },
        C6: { mean: 13.883057, sd: 4.109982 },
        A1: { mean: 13.17966, sd: 3.561862 },
        A2: { mean: 15.83245, sd: 3.176968 },
        A3: { mean: 15.748607, sd: 2.808495 },
        A4: { mean: 14.626731, sd: 3.457491 },
        A5: { mean: 11.175617, sd: 3.329278 },
        A6: { mean: 13.961522, sd: 3.320529 },
        E1: { mean: 13.920471, sd: 3.772532 },
        E2: { mean: 11.85551, sd: 4.021806 },
        E3: { mean: 14.780237, sd: 3.389787 },
        E4: { mean: 12.340672, sd: 3.191304 },
        E5: { mean: 12.652538, sd: 3.255585 },
        E6: { mean: 14.746266, sd: 3.408899 },
        O1: { mean: 14.784338, sd: 3.428472 },
        O2: { mean: 14.208852, sd: 3.644483 },
        O3: { mean: 14.115105, sd: 3.145074 },
        O4: { mean: 12.991798, sd: 3.34263 },
        O5: { mean: 15.588679, sd: 3.336773 },
        O6: { mean: 11.369902, sd: 3.728896 }
      },
      domains: {
        N: { mean: 63.481158, sd: 15.989574 },
        C: { mean: 87.935773, sd: 14.443854 },
        A: { mean: 84.524588, sd: 12.43992 },
        E: { mean: 80.295694, sd: 14.759228 },
        O: { mean: 83.058674, sd: 12.37843 }
      },
    },
    '35-44': {
      facets: {
        N1: { mean: 10.730221, sd: 3.659413 },
        N2: { mean: 11.140091, sd: 4.120354 },
        N3: { mean: 9.185462, sd: 3.874727 },
        N4: { mean: 11.534618, sd: 3.679635 },
        N5: { mean: 11.394265, sd: 3.548376 },
        N6: { mean: 8.811566, sd: 3.46374 },
        C1: { mean: 16.244777, sd: 2.540052 },
        C2: { mean: 13.114127, sd: 4.276613 },
        C3: { mean: 16.140528, sd: 2.740956 },
        C4: { mean: 16.262086, sd: 3.151356 },
        C5: { mean: 14.151893, sd: 3.275888 },
        C6: { mean: 14.539121, sd: 3.964923 },
        A1: { mean: 13.320264, sd: 3.523409 },
        A2: { mean: 16.512589, sd: 3.048786 },
        A3: { mean: 15.779177, sd: 2.788915 },
        A4: { mean: 15.096381, sd: 3.325466 },
        A5: { mean: 11.519844, sd: 3.277017 },
        A6: { mean: 14.230352, sd: 3.230505 },
        E1: { mean: 13.634671, sd: 3.858541 },
        E2: { mean: 11.27074, sd: 3.985467 },
        E3: { mean: 14.999432, sd: 3.399028 },
        E4: { mean: 12.71348, sd: 3.270343 },
        E5: { mean: 11.904362, sd: 3.182771 },
        E6: { mean: 14.465382, sd: 3.431761 },
        O1: { mean: 14.208191, sd: 3.464779 },
        O2: { mean: 14.054463, sd: 3.607279 },
        O3: { mean: 14.082787, sd: 3.069714 },
        O4: { mean: 13.006032, sd: 3.440787 },
        O5: { mean: 15.580339, sd: 3.348686 },
        O6: { mean: 10.835475, sd: 3.87897 }
      },
      domains: {
        N: { mean: 62.796223, sd: 16.155899 },
        C: { mean: 90.452531, sd: 14.145915 },
        A: { mean: 86.458607, sd: 12.077253 },
        E: { mean: 78.988067, sd: 14.774876 },
        O: { mean: 81.767287, sd: 12.463154 }
      },
    },
    '45-54': {
      facets: {
        N1: { mean: 10.395657, sd: 3.622023 },
        N2: { mean: 10.712265, sd: 4.103948 },
        N3: { mean: 8.974705, sd: 3.82093 },
        N4: { mean: 11.335414, sd: 3.610348 },
        N5: { mean: 10.693377, sd: 3.464331 },
        N6: { mean: 8.615161, sd: 3.452131 },
        C1: { mean: 16.360875, sd: 2.486577 },
        C2: { mean: 13.470794, sd: 4.271145 },
        C3: { mean: 16.497337, sd: 2.671315 },
        C4: { mean: 16.612498, sd: 3.001046 },
        C5: { mean: 14.479115, sd: 3.25015 },
        C6: { mean: 15.074222, sd: 3.773038 },
        A1: { mean: 13.684889, sd: 3.448593 },
        A2: { mean: 16.969712, sd: 2.926024 },
        A3: { mean: 16.024796, sd: 2.737019 },
        A4: { mean: 15.716592, sd: 3.258172 },
        A5: { mean: 11.863288, sd: 3.27549 },
        A6: { mean: 14.703445, sd: 3.136795 },
        E1: { mean: 13.676069, sd: 3.84708 },
        E2: { mean: 11.007655, sd: 3.903505 },
        E3: { mean: 15.106091, sd: 3.372442 },
        E4: { mean: 12.940423, sd: 3.317582 },
        E5: { mean: 11.320186, sd: 3.119275 },
        E6: { mean: 14.532701, sd: 3.458375 },
        O1: { mean: 13.956732, sd: 3.418027 },
        O2: { mean: 14.354801, sd: 3.494871 },
        O3: { mean: 14.295973, sd: 3.003261 },
        O4: { mean: 13.024297, sd: 3.437829 },
        O5: { mean: 15.583292, sd: 3.335167 },
        O6: { mean: 10.750707, sd: 4.003069 }
      },
      domains: {
        N: { mean: 60.726577, sd: 15.968877 },
        C: { mean: 92.494841, sd: 13.791575 },
        A: { mean: 88.962723, sd: 11.903636 },
        E: { mean: 78.583125, sd: 14.716266 },
        O: { mean: 81.965801, sd: 12.531485 }
      },
    },
    '55+': {
      facets: {
        N1: { mean: 10.059667, sd: 3.594858 },
        N2: { mean: 10.569353, sd: 4.121194 },
        N3: { mean: 8.443433, sd: 3.740828 },
        N4: { mean: 11.01511, sd: 3.59214 },
        N5: { mean: 9.965517, sd: 3.429243 },
        N6: { mean: 8.328749, sd: 3.431086 },
        C1: { mean: 16.370593, sd: 2.564043 },
        C2: { mean: 13.394421, sd: 4.365028 },
        C3: { mean: 16.697598, sd: 2.73087 },
        C4: { mean: 16.6821, sd: 3.067645 },
        C5: { mean: 14.555017, sd: 3.238707 },
        C6: { mean: 15.318094, sd: 3.881895 },
        A1: { mean: 13.923479, sd: 3.426612 },
        A2: { mean: 17.079233, sd: 3.074373 },
        A3: { mean: 16.082526, sd: 2.87776 },
        A4: { mean: 15.950794, sd: 3.393507 },
        A5: { mean: 11.810732, sd: 3.308409 },
        A6: { mean: 14.79969, sd: 3.278428 },
        E1: { mean: 13.943045, sd: 3.893597 },
        E2: { mean: 10.82778, sd: 3.918663 },
        E3: { mean: 15.005812, sd: 3.450197 },
        E4: { mean: 13.007361, sd: 3.438831 },
        E5: { mean: 10.824099, sd: 3.276163 },
        E6: { mean: 14.75649, sd: 3.44382 },
        O1: { mean: 13.877179, sd: 3.500827 },
        O2: { mean: 14.545331, sd: 3.583745 },
        O3: { mean: 14.266951, sd: 3.051586 },
        O4: { mean: 12.891515, sd: 3.552285 },
        O5: { mean: 15.644711, sd: 3.480908 },
        O6: { mean: 10.845796, sd: 4.218441 }
      },
      domains: {
        N: { mean: 58.381829, sd: 15.539303 },
        C: { mean: 93.017823, sd: 14.06811 },
        A: { mean: 89.646455, sd: 12.545826 },
        E: { mean: 78.364587, sd: 14.764599 },
        O: { mean: 82.071484, sd: 13.111276 }
      },
    }
  },
  F: {
    '<18': {
      facets: {
        N1: { mean: 13.274637, sd: 3.577783 },
        N2: { mean: 12.922205, sd: 4.133107 },
        N3: { mean: 10.315287, sd: 4.129522 },
        N4: { mean: 11.844755, sd: 3.557469 },
        N5: { mean: 12.1224, sd: 3.056079 },
        N6: { mean: 11.618678, sd: 3.438653 },
        C1: { mean: 15.268095, sd: 2.751828 },
        C2: { mean: 11.108204, sd: 4.098544 },
        C3: { mean: 15.311241, sd: 2.783472 },
        C4: { mean: 14.527784, sd: 3.390831 },
        C5: { mean: 13.093496, sd: 3.149711 },
        C6: { mean: 11.725634, sd: 3.981592 },
        A1: { mean: 13.311302, sd: 3.600785 },
        A2: { mean: 15.516069, sd: 3.066195 },
        A3: { mean: 16.397067, sd: 2.674902 },
        A4: { mean: 13.185563, sd: 3.924854 },
        A5: { mean: 13.391142, sd: 3.536454 },
        A6: { mean: 15.411685, sd: 2.966342 },
        E1: { mean: 14.809865, sd: 3.538447 },
        E2: { mean: 13.532957, sd: 4.039793 },
        E3: { mean: 13.742131, sd: 3.653066 },
        E4: { mean: 12.537815, sd: 3.091351 },
        E5: { mean: 14.331844, sd: 3.242817 },
        E6: { mean: 15.507046, sd: 3.376439 },
        O1: { mean: 15.826453, sd: 3.174205 },
        O2: { mean: 14.417129, sd: 3.714879 },
        O3: { mean: 15.239747, sd: 2.924923 },
        O4: { mean: 12.377051, sd: 3.019718 },
        O5: { mean: 13.771306, sd: 3.591985 },
        O6: { mean: 11.588465, sd: 2.875975 }
      },
      domains: {
        N: { mean: 72.097962, sd: 14.959719 },
        C: { mean: 81.034454, sd: 14.38501 },
        A: { mean: 87.212828, sd: 12.549077 },
        E: { mean: 84.461659, sd: 14.243105 },
        O: { mean: 83.220152, sd: 11.553187 }
      },
    },
    '18-24': {
      facets: {
        N1: { mean: 13.333436, sd: 3.549018 },
        N2: { mean: 11.949317, sd: 4.076661 },
        N3: { mean: 9.696069, sd: 3.847372 },
        N4: { mean: 11.835889, sd: 3.531253 },
        N5: { mean: 12.208051, sd: 3.285061 },
        N6: { mean: 11.333756, sd: 3.512464 },
        C1: { mean: 15.803271, sd: 2.496866 },
        C2: { mean: 12.820615, sd: 4.321765 },
        C3: { mean: 16.000256, sd: 2.607264 },
        C4: { mean: 15.403378, sd: 3.139381 },
        C5: { mean: 13.611092, sd: 3.142905 },
        C6: { mean: 12.962553, sd: 4.091416 },
        A1: { mean: 13.537077, sd: 3.555858 },
        A2: { mean: 16.327827, sd: 2.844044 },
        A3: { mean: 17.005434, sd: 2.420156 },
        A4: { mean: 14.858021, sd: 3.541858 },
        A5: { mean: 12.851237, sd: 3.348843 },
        A6: { mean: 15.477236, sd: 2.823482 },
        E1: { mean: 14.691321, sd: 3.41502 },
        E2: { mean: 12.930902, sd: 3.888293 },
        E3: { mean: 13.900833, sd: 3.514605 },
        E4: { mean: 12.785671, sd: 3.006271 },
        E5: { mean: 12.961686, sd: 3.218937 },
        E6: { mean: 15.638554, sd: 3.099739 },
        O1: { mean: 14.9824, sd: 3.309298 },
        O2: { mean: 14.744268, sd: 3.535749 },
        O3: { mean: 15.724171, sd: 2.798472 },
        O4: { mean: 11.984849, sd: 3.149757 },
        O5: { mean: 13.796202, sd: 3.570207 },
        O6: { mean: 11.621897, sd: 3.289777 }
      },
      domains: {
        N: { mean: 70.356517, sd: 15.014188 },
        C: { mean: 86.601166, sd: 14.035397 },
        A: { mean: 90.056833, sd: 11.415478 },
        E: { mean: 82.908967, sd: 13.516519 },
        O: { mean: 82.853786, sd: 11.884543 }
      },
    },
    '25-34': {
      facets: {
        N1: { mean: 12.879605, sd: 3.690957 },
        N2: { mean: 12.076218, sd: 4.084926 },
        N3: { mean: 9.98419, sd: 3.951874 },
        N4: { mean: 11.883407, sd: 3.711152 },
        N5: { mean: 12.383379, sd: 3.586181 },
        N6: { mean: 10.712704, sd: 3.629847 },
        C1: { mean: 16.094035, sd: 2.530727 },
        C2: { mean: 13.153699, sd: 4.487575 },
        C3: { mean: 16.276746, sd: 2.620681 },
        C4: { mean: 16.267978, sd: 3.046271 },
        C5: { mean: 13.996647, sd: 3.238746 },
        C6: { mean: 13.365071, sd: 4.261975 },
        A1: { mean: 13.234772, sd: 3.608397 },
        A2: { mean: 17.024915, sd: 2.762453 },
        A3: { mean: 17.050546, sd: 2.439518 },
        A4: { mean: 15.378861, sd: 3.38044 },
        A5: { mean: 12.761034, sd: 3.390267 },
        A6: { mean: 15.589658, sd: 2.91167 },
        E1: { mean: 14.251087, sd: 3.662506 },
        E2: { mean: 12.139909, sd: 4.010857 },
        E3: { mean: 14.230731, sd: 3.518609 },
        E4: { mean: 12.965349, sd: 3.191987 },
        E5: { mean: 11.965349, sd: 3.308403 },
        E6: { mean: 15.058262, sd: 3.259624 },
        O1: { mean: 14.533164, sd: 3.511796 },
        O2: { mean: 15.2075, sd: 3.388426 },
        O3: { mean: 16.040024, sd: 2.76404 },
        O4: { mean: 12.538509, sd: 3.381071 },
        O5: { mean: 14.732134, sd: 3.47704 },
        O6: { mean: 11.762731, sd: 3.472018 }
      },
      domains: {
        N: { mean: 69.919503, sd: 16.043469 },
        C: { mean: 89.154176, sd: 14.149542 },
        A: { mean: 91.039786, sd: 11.136307 },
        E: { mean: 80.610687, sd: 14.152577 },
        O: { mean: 84.814062, sd: 12.032124 }
      },
    },
    '35-44': {
      facets: {
        N1: { mean: 12.00778, sd: 3.697638 },
        N2: { mean: 11.362101, sd: 4.014411 },
        N3: { mean: 9.683255, sd: 3.942714 },
        N4: { mean: 11.702446, sd: 3.688436 },
        N5: { mean: 11.940005, sd: 3.637099 },
        N6: { mean: 10.164568, sd: 3.620829 },
        C1: { mean: 16.300723, sd: 2.493665 },
        C2: { mean: 13.575224, sd: 4.455847 },
        C3: { mean: 16.729476, sd: 2.547538 },
        C4: { mean: 16.912227, sd: 2.850878 },
        C5: { mean: 14.388958, sd: 3.229194 },
        C6: { mean: 14.035415, sd: 4.114575 },
        A1: { mean: 13.428983, sd: 3.518874 },
        A2: { mean: 17.608334, sd: 2.545027 },
        A3: { mean: 17.117915, sd: 2.418265 },
        A4: { mean: 16.048785, sd: 3.181359 },
        A5: { mean: 13.188716, sd: 3.317246 },
        A6: { mean: 15.884679, sd: 2.811333 },
        E1: { mean: 14.231594, sd: 3.737017 },
        E2: { mean: 11.66268, sd: 4.026937 },
        E3: { mean: 14.514624, sd: 3.478373 },
        E4: { mean: 13.297957, sd: 3.309576 },
        E5: { mean: 11.246492, sd: 3.288386 },
        E6: { mean: 15.011526, sd: 3.321866 },
        O1: { mean: 13.848803, sd: 3.547839 },
        O2: { mean: 15.160246, sd: 3.343752 },
        O3: { mean: 15.92992, sd: 2.721315 },
        O4: { mean: 12.628361, sd: 3.434175 },
        O5: { mean: 14.689883, sd: 3.474213 },
        O6: { mean: 11.261649, sd: 3.59222 }
      },
      domains: {
        N: { mean: 66.860156, sd: 16.082176 },
        C: { mean: 91.942022, sd: 13.727087 },
        A: { mean: 93.277411, sd: 10.584027 },
        E: { mean: 79.964873, sd: 14.317046 },
        O: { mean: 83.51886, sd: 12.076354 }
      },
    },
    '45-54': {
      facets: {
        N1: { mean: 11.526334, sd: 3.673507 },
        N2: { mean: 10.359097, sd: 3.88803 },
        N3: { mean: 9.288558, sd: 3.80808 },
        N4: { mean: 11.58893, sd: 3.633441 },
        N5: { mean: 11.319831, sd: 3.559814 },
        N6: { mean: 9.788235, sd: 3.558449 },
        C1: { mean: 16.537702, sd: 2.414746 },
        C2: { mean: 13.939439, sd: 4.406664 },
        C3: { mean: 17.116803, sd: 2.402798 },
        C4: { mean: 17.332241, sd: 2.659967 },
        C5: { mean: 14.68548, sd: 3.145824 },
        C6: { mean: 14.70618, sd: 3.932057 },
        A1: { mean: 13.868553, sd: 3.420085 },
        A2: { mean: 17.974981, sd: 2.354033 },
        A3: { mean: 17.311343, sd: 2.340623 },
        A4: { mean: 16.808637, sd: 2.925041 },
        A5: { mean: 13.328121, sd: 3.248687 },
        A6: { mean: 16.141723, sd: 2.737401 },
        E1: { mean: 14.378158, sd: 3.702815 },
        E2: { mean: 11.230181, sd: 3.938515 },
        E3: { mean: 14.603425, sd: 3.413814 },
        E4: { mean: 13.386001, sd: 3.334779 },
        E5: { mean: 10.585108, sd: 3.163018 },
        E6: { mean: 15.13105, sd: 3.288727 },
        O1: { mean: 13.493919, sd: 3.538857 },
        O2: { mean: 15.563316, sd: 3.200457 },
        O3: { mean: 15.992355, sd: 2.688365 },
        O4: { mean: 12.738446, sd: 3.456562 },
        O5: { mean: 14.753785, sd: 3.512663 },
        O6: { mean: 11.239464, sd: 3.795369 }
      },
      domains: {
        N: { mean: 63.870985, sd: 15.585641 },
        C: { mean: 94.317846, sd: 12.995321 },
        A: { mean: 95.433358, sd: 9.926084 },
        E: { mean: 79.313924, sd: 14.042138 },
        O: { mean: 83.781286, sd: 12.255258 }
      },
    },
    '55+': {
      facets: {
        N1: { mean: 11.182927, sd: 3.739734 },
        N2: { mean: 9.918386, sd: 3.895496 },
        N3: { mean: 8.842245, sd: 3.728927 },
        N4: { mean: 11.268449, sd: 3.62616 },
        N5: { mean: 10.746404, sd: 3.517068 },
        N6: { mean: 9.498749, sd: 3.55603 },
        C1: { mean: 16.456223, sd: 2.487647 },
        C2: { mean: 13.958255, sd: 4.398732 },
        C3: { mean: 17.33177, sd: 2.394742 },
        C4: { mean: 17.258599, sd: 2.784697 },
        C5: { mean: 14.649312, sd: 3.192309 },
        C6: { mean: 14.882583, sd: 3.923921 },
        A1: { mean: 14.217636, sd: 3.399146 },
        A2: { mean: 18.101001, sd: 2.422618 },
        A3: { mean: 17.377892, sd: 2.448776 },
        A4: { mean: 17.204503, sd: 2.970338 },
        A5: { mean: 13.283146, sd: 3.1556 },
        A6: { mean: 16.275328, sd: 2.906953 },
        E1: { mean: 14.718887, sd: 3.684351 },
        E2: { mean: 11.154784, sd: 3.840624 },
        E3: { mean: 14.388837, sd: 3.480942 },
        E4: { mean: 13.263915, sd: 3.489793 },
        E5: { mean: 10.146967, sd: 3.201003 },
        E6: { mean: 15.254378, sd: 3.386796 },
        O1: { mean: 13.240775, sd: 3.618154 },
        O2: { mean: 15.80566, sd: 3.230412 },
        O3: { mean: 15.811757, sd: 2.777812 },
        O4: { mean: 12.677767, sd: 3.535476 },
        O5: { mean: 14.787836, sd: 3.594738 },
        O6: { mean: 11.391807, sd: 4.03069 }
      },
      domains: {
        N: { mean: 61.457161, sd: 15.419986 },
        C: { mean: 94.536742, sd: 12.980314 },
        A: { mean: 96.459506, sd: 10.582093 },
        E: { mean: 78.927767, sd: 14.138733 },
        O: { mean: 83.715604, sd: 12.736407 }
      },
    }
  }
}

/**
 * Get the age group key from a numeric age.
 * Matches the age brackets used in the IPIP-NEO norm tables.
 */
export function getAgeGroup(age) {
  if (age < 18) return '<18'
  if (age <= 24) return '18-24'
  if (age <= 34) return '25-34'
  if (age <= 44) return '35-44'
  if (age <= 54) return '45-54'
  return '55+'
}

/**
 * Get norms for a specific gender and age.
 * @param {string} gender - "M" or "F"
 * @param {number} age - numeric age
 * @returns {{ facets: Object, domains: Object }}
 */
export function getNorms(gender, age) {
  const ageGroup = getAgeGroup(age)
  const genderNorms = NORMS[gender]
  if (!genderNorms) throw new Error(`Unknown gender: ${gender}`)
  const norms = genderNorms[ageGroup]
  if (!norms) throw new Error(`Unknown age group: ${ageGroup}`)
  return norms
}
